import React, { useContext, useState } from "react";
import { fetchopencompnestedtable } from "./apiInsights";
import { FilterContext } from "../../context/Filter";

const Opencomplainttb = ({ data = [], loading }) => {
    const [expandedRow, setExpandedRow] = useState(null);
    const [nestedData, setNestedData] = useState({});
    const [loadingRow, setLoadingRow] = useState(null);

    const { superArn, childArn } = useContext(FilterContext);
    const finalArn = childArn || superArn;

    const payload1 = { arn: finalArn };

    const getopencompinsidetb = async (problem_area, index) => {
        setLoadingRow(index);
        try {
            const payload = {
                ...payload1,
                problem_area, // ✅ correct key name
            };


            const response = await fetchopencompnestedtable(payload);

            setNestedData((prev) => ({
                ...prev,
                [problem_area]: response || [],
            }));
        } catch (error) {
            console.error("❌ Error fetching nested complaint table:", error);
        } finally {
            setLoadingRow(null);
        }
    };

    if (loading) return <p className="p-4 text-blue-500">Loading...</p>;
    if (!data || data.length === 0)
        return <p className="p-4 text-gray-500">No data available</p>;

    return (
        <div className="p-4">
            <table className="min-w-full border border-blue-500 bg-white shadow-md rounded-lg overflow-hidden">
                <thead className="bg-[#267CB8] text-white">
                    <tr>
                        <th className="px-4 py-2 text-center w-16">S.No</th>
                        <th className="px-4 py-2 text-left">Problem Area</th>
                        <th className="px-4 py-2 text-center w-24">Count</th>
                    </tr>
                </thead>

                <tbody>
                    {data.map((item, i) => {
                        // ✅ Proper extraction of problem area value
                        const problemArea =
                            typeof item.key === "object"
                                ? Object.values(item.key)[0]
                                : item.key || item.problem_area || "Unknown";

                        const count = item.doc_count;
                        const isExpanded = expandedRow === i;
                        const nestedRows = nestedData[problemArea] || [];

                        return (
                            <React.Fragment key={i}>
                                <tr
                                    className={`${i % 2 === 0 ? "bg-white" : "bg-blue-50"
                                        } transition-all duration-200`}
                                >
                                    <td className="px-4 py-2 border-t border-blue-200 text-center">
                                        {i + 1}
                                    </td>
                                    <td className="px-4 py-2 border-t border-blue-200 text-left">
                                        {problemArea}
                                    </td>
                                    <td
                                        className="px-4 py-2 border-t border-blue-200 text-center text-blue-600 font-semibold cursor-pointer hover:underline"
                                        onClick={() => {
                                            if (isExpanded) {
                                                setExpandedRow(null);
                                            } else {
                                                setExpandedRow(i);
                                                getopencompinsidetb(problemArea, i);
                                            }
                                        }}
                                    >
                                        {loadingRow === i ? "Loading..." : count}
                                    </td>
                                </tr>

                                {/* Nested Table */}
                                {isExpanded && (
                                    <tr className="bg-gray-50">
                                        <td colSpan="3" className="px-6 py-3 border-t border-blue-200">
                                            {loadingRow === i ? (
                                                <p className="text-blue-500 text-sm">
                                                    Loading nested data...
                                                </p>
                                            ) : nestedRows.length > 0 ? (
                                                <div className="overflow-x-auto">
                                                    <table className="min-w-full border border-gray-300 rounded-lg">
                                                        <thead className="bg-gray-200 text-gray-700">
                                                            <tr>
                                                                <th className="px-3 py-1 text-left text-sm">
                                                                    Complaint No
                                                                </th>
                                                                <th className="px-3 py-1 text-left text-sm">
                                                                    Date
                                                                </th>
                                                                <th className="px-3 py-1 text-left text-sm">
                                                                    Chassis No
                                                                </th>
                                                                <th className="px-3 py-1 text-left text-sm">
                                                                    Dealer
                                                                </th>
                                                                <th className="px-3 py-1 text-left text-sm">
                                                                    State
                                                                </th>
                                                                <th className="px-3 py-1 text-left text-sm">PL</th>
                                                                <th className="px-3 py-1 text-left text-sm">LOB</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {nestedRows.map((row, idx) => (
                                                                <tr
                                                                    key={idx}
                                                                    className={`${idx % 2 === 0 ? "bg-white" : "bg-gray-50"
                                                                        } text-sm`}
                                                                >
                                                                    <td className="px-3 py-1 border-t">
                                                                        {row.COMPLAINT_NO}
                                                                    </td>
                                                                    <td className="px-3 py-1 border-t">
                                                                        {row.COMPLAINT_DATE_TIME}
                                                                    </td>
                                                                    <td className="px-3 py-1 border-t">
                                                                        {row.CHASSIS_NO}
                                                                    </td>
                                                                    <td className="px-3 py-1 border-t">
                                                                        {row.DEALER}
                                                                    </td>
                                                                    <td className="px-3 py-1 border-t">
                                                                        {row.SRV_OU_STATE}
                                                                    </td>
                                                                    <td className="px-3 py-1 border-t">{row.PL}</td>
                                                                    <td className="px-3 py-1 border-t">{row.LOB}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <p className="text-gray-500 text-sm text-center">
                                                    No nested data found for this problem area.
                                                </p>
                                            )}
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default Opencomplainttb;
